
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"172","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"ArrowNextLong-Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"ArrowNextLong-MVP","transform":"translate(-156 -402)","fill":"#000"}},[_c('g',{attrs:{"id":"ArrowNextLong-M024-Carousel-Right-/-01-Desktop","transform":"translate(0 320)"}},[_c('g',{attrs:{"id":"ArrowNextLong-Carousel-Right-/-01-Desktop"}},[_c('g',{attrs:{"id":"ArrowNextLong-Pagination","transform":"translate(156 82)"}},[_c('g',{attrs:{"id":"ArrowNextLong-Icon-/-Arrow","transform":"matrix(0 -1 -1 0 171.5 14.5)"}},[_c('path',{attrs:{"d":"M7.164.333l-.47.471L.862 6.636a.667.667 0 00.942.943l4.694-4.694v167.047c0 .369 0 .667.666.667.667 0 .667-.298.667-.667V2.885l4.693 4.694a.665.665 0 00.943 0 .666.666 0 000-.943L7.164.333z","id":"ArrowNextLong-Fill-1"}})])])])])])])])
          )
        }
      }
    